import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import Cookies from "universal-cookie"
import clsx from "clsx"

const CookiePolicy = () => {
  const cookies = new Cookies()
  const cookieName = "slice-mark-cookieAccept"
  const [show, setShow] = useState(false)

  const popupClass = clsx(
    "bg-black fixed bottom-0 left-0 right-0 text-white p2 transition-all duration-300 translate-y-full",
    {
      "translate-y-0": show,
    }
  )

  const acceptCookies = () => {
    const CookieDate = new Date()
    CookieDate.setFullYear(CookieDate.getFullYear() + 10)
    cookies.set(cookieName, "true", {
      path: "/",
      expires: CookieDate,
    })
    closePopup()
  }

  const checkCookie = () => {
    const accept = !!cookies.get(cookieName)
    setShow(!accept)
  }

  const closePopup = () => {
    setShow(false)
  }

  useEffect(() => {
    checkCookie()
  }, ["once"])

  return (
    <div className={popupClass}>
      <div className="container py-8 lg:flex">
        <p className="mb-10 lg:mb-0 lg:mr-8">
          We use cookies and other tracking technologies to improve your
          browsing experience on our website, to analyze our website traffic,
          and to understand where our visitors are coming from. Please read our
          cookie policy for more information. By browsing our website, you
          consent to our use of cookies and other tracking technologies. View
          our <Link to="/cookie-policy/">Cookie Policy</Link>.
        </p>
        <div className="flex justify-between items-center min-w-[25rem]">
          <button className="lg:order-2 underline" onClick={closePopup}>
            Close
          </button>
          <button
            className="lg:order-1 bg-white text-black rounded-full px-8 py-4 font-bold"
            onClick={acceptCookies}
          >
            Accept Cookies
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookiePolicy
